import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_LOCALES } from "@faire/web--source/common/consts/DEFAULT_LOCALES";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { da } from "date-fns/locale/da";
import { de } from "date-fns/locale/de";
import { enUS } from "date-fns/locale/en-US";
import { es } from "date-fns/locale/es";
import { fr } from "date-fns/locale/fr";
import { it } from "date-fns/locale/it";
import { nl } from "date-fns/locale/nl";
import { pt } from "date-fns/locale/pt";
import { sv } from "date-fns/locale/sv";
import { LocalizationStore } from "../LocalizationStore";
/**
 * @deprecated use `useDateLocaleStore` or `withStores` instead
 */
export var DateLocaleStore = /*#__PURE__*/function () {
  function DateLocaleStore() {
    var _this = this;
    _classCallCheck(this, DateLocaleStore);
    this.init = function () {
      var _locale$split$;
      var locale = LocalizationStore.get().locale;
      var simplifiedLocale = (_locale$split$ = locale.split("-")[0]) !== null && _locale$split$ !== void 0 ? _locale$split$ : "";
      _this._dateLocale =
      // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      DATE_LOCALES[locale] ||
      // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      DATE_LOCALES[simplifiedLocale] || DATE_LOCALES["en"];
    };
    this.init();
  }
  return _createClass(DateLocaleStore, [{
    key: "dateLocale",
    get: function get() {
      return this._dateLocale;
    }
  }]);
}();
DateLocaleStore.get = singletonGetter(DateLocaleStore);
var gibberishDateLocal = _objectSpread(_objectSpread({}, enUS), {}, {
  code: DEFAULT_LOCALES[Language.GIBBERISH]
});
var DATE_LOCALES = {
  "en-US": enUS,
  en: enUS,
  "fr-FR": fr,
  fr: fr,
  "de-DE": de,
  de: de,
  "it-IT": it,
  it: it,
  "es-ES": es,
  es: es,
  "sv-SE": sv,
  sv: sv,
  "pt-PT": pt,
  pt: pt,
  "da-DK": da,
  da: da,
  "nl-NL": nl,
  nl: nl,
  xa: gibberishDateLocal
};